import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';
import { RouterLink } from 'src/routes/components';

import { useTenant } from 'src/auth/context/firebase/TenantContext';
import axios from 'axios';

// ----------------------------------------------------------------------

const ClientLogo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();
  const tenant = useTenant();
  const [logoUrl, setLogoUrl] = useState(null); // No default logo

  useEffect(() => {
  const fetchLogo = async () => {
    if (tenant) {
      setLogoUrl(null); // Reset logo URL when tenant changes
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/tenants/${tenant.selectedTenant}`
        );
        if (response.data?.description) {
          setLogoUrl(response.data.description);
        }
      } catch (error) {
        console.error('Failed to fetch logo:', error);
        setLogoUrl(null); // Ensure state is explicitly cleared on error
      }
    }
  };

  fetchLogo();
}, [tenant]);


  if (!logoUrl) {
    // Do not render anything if logoUrl is null or undefined
    return null;
  }

  const logo = (
    <Box
      component="img"
      src={logoUrl}
      alt="Client Logo"
      sx={{ width: 200, height: 87, cursor: 'pointer', ...sx }}
    />
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});ClientLogo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default ClientLogo;

